import { Redirect } from "wouter";

export default function TasksPage() {
  return <Redirect to="/fields/field-sync" />;
}
